export const controlDeviceQuickWhitelistingSelector = state => state.ui.controlDeviceQuickWhitelisting;
